import { Icon, IconProps } from "../";

export const ArrowFirstIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2603 6.0496C17.5639 5.76775 17.5814 5.2932 17.2996 4.98966C17.0177 4.68613 16.5432 4.66856 16.2397 4.95041L9.23966 11.4504C9.08683 11.5923 9 11.7915 9 12C9 12.2086 9.08683 12.4077 9.23966 12.5496L16.2397 19.0496C16.5432 19.3314 17.0177 19.3139 17.2996 19.0103C17.5814 18.7068 17.5639 18.2323 17.2603 17.9504L10.8522 12L17.2603 6.0496ZM8 5.5C8 5.08579 7.66421 4.75 7.25 4.75C6.83579 4.75 6.5 5.08579 6.5 5.5V18.5C6.5 18.9142 6.83579 19.25 7.25 19.25C7.66421 19.25 8 18.9142 8 18.5V5.5Z"
      />
    </Icon>
  );
};
